import StepCard from "./StepCard";
import { brandGradient, classNames, highlight } from "./utils";

export default function SectionBlock({ id, title, items, query }) {
  if (!items?.length) return null;
  return (
    <section id={id} className="scroll-mt-24 mt-6">
      <a data-anchor href={`#${id}`} className="sr-only">
        {title}
      </a>
      <div className="flex items-center gap-3 mb-3">
        <div className={classNames(brandGradient, "h-7 w-1 rounded-full")} />
        <h2 className="text-xl font-bold text-slate-900 dark:text-white">
          {highlight(title, query)}
        </h2>
      </div>
      <div className="space-y-5">
        {items.map((s, i) => (
          <div
            key={i}
            id={`step-${id}-${i}`}
            data-section={id}
            className="rounded-2xl p-4 md:p-6 border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900"
          >
            <StepCard step={s} q={query} />
          </div>
        ))}
      </div>
    </section>
  );
}
